import { mapMessageModel } from 'stores/adapters';

import { HotelMessagingResult } from 'models';

export const getPropertyLevelOffersMessage = (response: any) => response?.data?.propertyInfo?.offers?.propertyLevelOffersMessage;
export const getLegalbannerMessage = (response: any) => response?.data?.propertyInfo?.offers?.legalBanner;

export const adaptMessagingCard = (response: any): HotelMessagingResult | null => {
  const propMessage = getPropertyLevelOffersMessage(response);

  if (!propMessage) {
    return null;
  }

  return {
    model: mapMessageModel(propMessage, propMessage.__typename),
  } as HotelMessagingResult;
};

export const adaptLegalBannerMessagingCard = (response: any): HotelMessagingResult | undefined => {
  const legalBannerMessage = getLegalbannerMessage(response);

  if (!legalBannerMessage) {
    return undefined;
  }

  return {
    model: mapMessageModel(legalBannerMessage, 'MessageResult'),
  } as HotelMessagingResult;
};
